var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.367h2.969c2.148 0 3.906-1.14 3.906-3.265s-2.07-3.183-3.75-3.266C15.278 4.514 12.852 2.492 10 2.492c-2.695 0-4.431 1.79-5 3.563C2.656 6.278.625 7.769.625 10.21c0 2.442 2.11 4.156 4.688 4.156H7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 9.992-2.5-2.5-2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.509V8.117"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff"
  })))));
};
export { SvgUpload as ReactComponent };